__turbopack_context__.v({
  "fade-in": "CampaignPage-module-scss-module__poKNhq__fade-in",
  "mainSection": "CampaignPage-module-scss-module__poKNhq__mainSection",
  "no-transform": "CampaignPage-module-scss-module__poKNhq__no-transform",
  "productSection": "CampaignPage-module-scss-module__poKNhq__productSection",
  "rotate": "CampaignPage-module-scss-module__poKNhq__rotate",
});
